module.exports = __webpack_public_path__ + "img/preview.6a502fc4.svg";